<div class="container">

  <div class="logo">

    <img class="img-logo fade-blur" src="/assets/logos.png" />
  </div>
  <app-change-language class="float"></app-change-language>
</div>
